import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendService } from '../backend/backend.service';
import { AssistantChatInstructions } from '../../interfaces/assistant-chat.interface';

@Injectable({ providedIn: 'root' })
export class AssistantChatInstructionsService {
  private readonly backendService = inject(BackendService);

  public load(): Observable<AssistantChatInstructions> {
    return this.backendService.load('/assistant/instructions', { skipLoader: true, throwErrors: true });
  }

  public save(text: string): Observable<AssistantChatInstructions> {
    return this.backendService.update('/assistant/instructions', { text }, { skipLoader: true, throwErrors: true });
  }
}
